export default {
    /**
     * 获取当前门店
     */
    getStoreInfo:()=>{
        let storeInfo = sessionStorage.getItem('adminStoreInfo');
        if(storeInfo){
            return JSON.parse(storeInfo);
        }else{
            return null
        }
    },
    /**
     * 获取当前用户
     */
    getUserInfo:()=>{
        let userInfo = sessionStorage.getItem('adminStaffInfo');
        if(userInfo){
            return JSON.parse(userInfo);
        }else{
            return null
        } 
    },
    /**
     * 获取当前用户可操作区
     */
    getUserArea:()=>{
        let userArea = sessionStorage.getItem('adminStaffArea');
        if(userArea){
            return JSON.parse(userArea);
        }else{
            return null
        } 
    },


}